export const shotNavStatusColors = {
  red:    { bg: 'rgba(220, 38, 38, 0.08)',  hoverBg: 'rgba(220, 38, 38, 0.14)',  color: 'var(--danger)' },
  yellow: { bg: 'rgba(250, 204, 21, 0.18)', hoverBg: 'rgba(250, 204, 21, 0.32)', color: 'var(--warning)' },
  green:  { bg: 'rgba(42, 157, 153, 0.08)', hoverBg: 'rgba(42, 157, 153, 0.14)', color: 'var(--success)' },
} as const;

export type IneligibleReason = 'cross-platform' | 'no-completed-at' | 'expired';

export const INELIGIBLE_LABEL_KEYS: Record<IneligibleReason, string> = {
  'cross-platform': 'ineligible.crossPlatform',
  'no-completed-at': 'ineligible.noCompletedAt',
  'expired': 'ineligible.expired',
};

export const INELIGIBLE_TITLE_KEYS: Record<IneligibleReason, string> = {
  'cross-platform': 'ineligible.crossPlatformTitle',
  'no-completed-at': 'ineligible.noCompletedAtTitle',
  'expired': 'ineligible.expiredTitle',
};

// 截取片段时长限制（与后端 internal/service/clip 常量保持一致）
export const MIN_CLIP_SECONDS = 2.5;
export const MAX_CLIP_SECONDS = 14.5;

// 分镜版本视频帧率：Seedance 系列产物固定 24fps，前端无法从 <video> 读取实际帧率，
// 截取弹窗的帧号显示与 ±1 帧微调都按此常量换算
export const CLIP_FRAME_RATE = 24;
